<div *ngIf="row && row.details">
  <div class="atgard-content-wrapper">
    <div class="provdata-content" style="background-color: white; width: 100%; border-radius: 1rem">
      <p-panel header="Provdata">
        <div class="atgard-content">
          <div class="text-main">Prov ID</div>
          <div>
            <p-toast key="toast-copy"></p-toast>
            <span>{{ row.provId }}</span>
            <p-button icon="fas fa-copy" pTooltip="Kopiera" (click)="copy(row.provId)" [link]="true"></p-button>
          </div>
          <div></div>
          <div></div>

          <div class="text-main">Provtagningsdatum</div>
          <div>
            {{ row.details.provdata.provtagnings_datum | date: "yyyy-MM-dd" }}
          </div>
          <div></div>
          <div></div>

          <div class="text-main">Labbkod</div>
          <div>{{ row.labCode }}</div>
          <div></div>
          <div></div>

          <div class="text-main">Kön</div>
          <div>{{ row.details.gender }}</div>
          <div></div>
          <div></div>

          <div class="text-main">Analys</div>
          <div>
            <span
              [ngClass]="{
                'text-highlight text-ellipsis bg-red': getStatus(row.details) === okandNamnStatus.AtgardBehovs,
              }"
            >
              {{ row.details.analysName }}
            </span>
          </div>
          <div></div>
          <div>
            <app-status
              *ngIf="row.details.nameStatus !== nameStatus.Oforandrat"
              [type]="getToastStatusType(row.details)"
              [clickable]="true"
              (onClick)="atgarda(row, type.Analys)"
              >{{ getStatusText(row.details) }}</app-status
            >
          </div>

          <div class="text-main">Provmaterial</div>
          <div>
            <span
              [ngClass]="{
                'text-highlight text-ellipsis bg-red': getStatus(row.details.provdata) === okandNamnStatus.AtgardBehovs,
              }"
            >
              {{ row.details.provdata.provmaterialName }}
            </span>
          </div>
          <div></div>
          <div>
            <app-status
              *ngIf="row.details.provdata.nameStatus !== nameStatus.Oforandrat || row.details.provdata.ignored"
              [type]="getToastStatusType(row.details.provdata)"
              [clickable]="true"
              (onClick)="atgarda(row, type.Provmaterial)"
              >{{ getStatusText(row.details.provdata) }}</app-status
            >
          </div>
        </div>
      </p-panel>
    </div>
    <div class="d-flex justify-content-end px-2 mb-2">
      <app-button-set [buttons]="viewToggleButtons" (select)="onViewToggle($event)"></app-button-set>
    </div>
    <div #panelView *ngIf="fyndView === 'panel'" style="background-color: white; width: 100%; border-radius: 1rem">
      <p-panel header="Fynd">
        <p-tabs (valueChange)="setCurrentFynd(+$event!)">
          <p-tablist>
            <!--<p-tabPanel *ngFor="let fynd of row.details.fyndList" [header]="fynd.smittamneName"> -->
            <p-tab *ngFor="let fynd of row.details.fyndList; let i = index" [value]="i">
              {{ fynd.smittamneName }}
            </p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel *ngFor="let fynd of row.details.fyndList; let i = index" [value]="i">
              <div class="atgard-content">
                <div class="text-main">Smittämne</div>
                <div>
                  <span
                    [ngClass]="{
                      'text-highlight text-ellipsis bg-red': getStatus(fynd) === okandNamnStatus.AtgardBehovs,
                    }"
                  >
                    {{ fynd.smittamneName }}
                  </span>
                </div>
                <div></div>
                <div>
                  <app-status
                    *ngIf="fynd.nameStatus !== nameStatus.Oforandrat"
                    [type]="getToastStatusType(fynd)"
                    [clickable]="true"
                    (onClick)="atgarda(row, type.Smittamne, fynd)"
                    >{{ getStatusText(fynd) }}</app-status
                  >
                </div>
              </div>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </p-panel>
      <p-panel header="Antibiotika">
        <ng-container *ngIf="currentFynd.antimicroList.length > 0">
          <ng-container *ngFor="let antibiotic of currentFynd.antimicroList">
            <div class="atgard-content">
              <div class="text-main">Antibiotika</div>
              <div>
                <span
                  [ngClass]="{
                    'text-highlight text-ellipsis bg-red': getStatus(antibiotic) === okandNamnStatus.AtgardBehovs,
                  }"
                >
                  {{ antibiotic.name }}
                  <i
                    *ngIf="antibiotic.antibiotikumDubblett !== antibiotikaDubblett.INGEN_DUBBLETT"
                    class="fa-solid fa-triangle-exclamation"
                  ></i>
                </span>
              </div>
              <div></div>
              <div>
                <app-status
                  *ngIf="antibiotic.nameStatus !== nameStatus.Oforandrat || antibiotic.ignored"
                  [type]="getToastStatusType(antibiotic)"
                  [clickable]="true"
                  (onClick)="atgarda(row, type.Antibiotika, undefined, antibiotic)"
                  >{{ getStatusText(antibiotic) }}</app-status
                >
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="currentFynd.antimicroList.length === 0">
          <p>Det finns inga antibiotika för detta fynd</p>
        </ng-container>
      </p-panel>
    </div>

    <div #fullView *ngIf="fyndView === 'full'" class="full-view-content-wrapper">
      <div class="full-view-title">Fynd</div>
      <div *ngFor="let fynd of row.details.fyndList">
        <div class="full-view-content">
          <div class="text-main">Smittämne</div>
          <div>
            <span
              [ngClass]="{
                'text-highlight text-ellipsis bg-red': getStatus(fynd) === okandNamnStatus.AtgardBehovs,
              }"
            >
              {{ fynd.smittamneName }}
            </span>
          </div>
          <div></div>
          <div>
            <app-status
              *ngIf="fynd.nameStatus !== nameStatus.Oforandrat"
              [type]="getToastStatusType(fynd)"
              [clickable]="true"
              (onClick)="atgarda(row, type.Smittamne, fynd)"
              >{{ getStatusText(fynd) }}</app-status
            >
          </div>
        </div>
        <div class="full-view-content antibiotic-wrapper">
          <ng-container *ngFor="let antibiotic of fynd.antimicroList">
            <div style="padding-left: 2rem" class="text-main">Antibiotika</div>
            <div>
              <span
                [ngClass]="{
                  'text-highlight text-ellipsis bg-red': getStatus(antibiotic) === okandNamnStatus.AtgardBehovs,
                }"
              >
                {{ antibiotic.name }}
                <i
                  *ngIf="antibiotic.antibiotikumDubblett !== antibiotikaDubblett.INGEN_DUBBLETT"
                  class="fa-solid fa-triangle-exclamation"
                ></i
              ></span>
            </div>
            <div></div>
            <div>
              <app-status
                *ngIf="antibiotic.nameStatus !== nameStatus.Oforandrat || antibiotic.ignored"
                [type]="getToastStatusType(antibiotic)"
                [clickable]="true"
                (onClick)="atgarda(row, type.Antibiotika, undefined, antibiotic)"
                >{{ getStatusText(antibiotic) }}</app-status
              >
            </div></ng-container
          >
        </div>
      </div>
    </div>
  </div>
</div>
